import { cn } from '../../lib/utils';
import logoSvg from '@packages/brand/bill-logo.svg';

interface BillLogoProps {
  className?: string;
}

export function BillLogo({ className }: BillLogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <img src={logoSvg} alt="" aria-hidden="true" className="h-6 w-6 shrink-0" />
      <span className="font-serif font-bold">Bill</span>
    </span>
  );
}
